import { ClickableOptionsCard, ResetPasswordModal } from 'core/Components';

import { ChangePasswordModal } from './ChangePassword';
import {
  ChangePasswordModalProvider,
  useChangePasswordModalProvider,
} from './ChangePasswordProvider';

const ChangePasswordActionIcon = () => {
  const { openModalById } = useChangePasswordModalProvider({});

  return (
    <ClickableOptionsCard.Row
      title="Change Password"
      onClick={() => openModalById('ChangePassword')}
    />
  );
};

const ResetPasswordWrapper = () => {
  const { opened, close, openPreviousStep, props } = useChangePasswordModalProvider({
    id: 'ResetPassword',
  });

  return (
    <ResetPasswordModal
      opened={opened}
      onClose={() => openPreviousStep()}
      onSuccess={() => close()}
      modalProps={props}
    />
  );
};

const ChangePasswordModalGroup = () => {
  return (
    <ChangePasswordModalProvider meta={{}}>
      <ChangePasswordActionIcon />
      <ChangePasswordModal />
      <ResetPasswordWrapper />
    </ChangePasswordModalProvider>
  );
};

export { ChangePasswordModalGroup };
